export default __webpack_public_path__ + "static/media/amex.af2f16dd.png";